<template>
  <div class="wrapper signin__image--bg">
    <section class="signin">
      <div class="signin__image">
        <p>入力したメールアドレスへ認証コードを<br>お送りしました。</p>
        <p>認証コードと再設定パスワードを入力してください。</p>
      </div>
      <div class="signin__input">
        <input type="number" maxlength="6" v-model="param_password.code" placeholder="認証コードを入力してください">
      </div>
      <div class="signin__input">
        <input type="password" v-model="param_password.password" placeholder="再設定パスワードを入力してください">
        <input type="password" v-model="param_password.register_password" placeholder="再度パスワードを入力してください">
      </div>
      <button type="submit" class="signin__button" :class="{active: is_active}" @click="reregist">設定完了</button>
    </section>
  </div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		data() {
			return {
			  param_password: {
			    code: "",
			    password: "",
          register_password: "",
        },
        is_active: false,
			}
		},
		methods: {
			// パス再設定
			async reregist() {
			  if (!this.is_active) {
			    return
        }
				if (this.param_password.code.length !== 6) {
					navigator.notification.alert('認証コードを正しく入力してください。', null, '', 'OK')
					return
				}
				if(this.param_password.password !== this.param_password.register_password) {
					navigator.notification.alert('パスワードが一致しません。', null, '', 'OK')
					return
				}
				if(this.param_password.password.length < 8) {
					navigator.notification.alert('パスワードは8文字以上で入力してください。', null, '', 'OK')
					return
				}

				await this.$store.dispatch('authorize/reregistApi', this.param_password)
				if (this.resetApiStatus) {
					navigator.notification.alert(
					    'パスワード再設定が完了しました。',
              () => {
					      this.$router.push('/')
              },
              '',
              'OK'
          )
				}
			},
		},
    watch: {
      param_password: {
        handler(value) {
          this.is_active = value.code.length === 6 && value.password.length >= 8 && value.register_password.length >= 8
        },
        deep: true
      }
    },
		computed: {
			...mapState({
				resetApiStatus: state => state.authorize.apiStatus
			})
		}
	}
</script>
